import { createAction } from '@reduxjs/toolkit';

export const FETCH_OUT_DISPOSITIONS_ACTION_TYPE = 'saga/fetchOutDispositions';
export const fetchOutDispositionsAction = createAction(FETCH_OUT_DISPOSITIONS_ACTION_TYPE);
